import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component } from "@angular/core";

import { FooterComponent } from "../../components/common/footer/footer";
import { NavigationComponent } from "../../components/common/navigation/navigation";
import { NotFoundComponent } from "../../components/common/not-found/not-found";

@Component({
  selector: "page-notfound",
  templateUrl: "notfound.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FooterComponent, NavigationComponent, TranslatePipe, NotFoundComponent],
})
export class NotfoundPage {}
